import * as types from '../mutation-types';
import { get_dashboard, get_paymentTypes, summary_sale_report_by_category, top_sale_items } from '@/api/dashboard';
import { data } from 'jquery';


export const state = {
    report: {},
    loading: false,
    category: [],
    loading_category: false,
    loading_top_sales: false,
    topsales: [],
    paymentTypes: [],
}
export const getters = {
    loading: state => state.loading,
    report: state => state.report,
    category: state => state.category,
    loading_category: state => state.loading_category,
    loading_top_sales: state => state.loading_top_sales,
    topsales: state => state.topsales,
    paymentTypes: state => state.paymentTypes
}
export const mutations = {

    [types.DARSHBOARD](state, payload) {
        state.loading = true;
    },
    [types.DARSHBOARD_FAIL](state, payload) {
        state.loading = false;
        state.report = {};
    },
    [types.DARSHBOARD_SUCCESS](state, payload) {
        state.loading = false;
        state.report = payload;
    },
    [types.DARSHBOARD_CATEGORY](state, payload) {
        state.loading_category = true;
    },
    [types.DARSHBOARD_CATEGORY_FAIL](state, payload) {
        state.loading_category = false;
        state.category = [];
    },
    [types.DARSHBOARD_CATEGORY_SUCCESS](state, payload) {
        state.loading_category = false;
        state.category = [...state.category, ...payload];
    },
    topSale(state) {
        state.loading_top_sales = true;
    },
    topSaleFail(state) {
        state.loading_top_sales = false;
        state.topsales = [];
    },
    topSaleDone(state, payload) {
        state.loading_top_sales = false;
        state.topsales = [...state.topsales, ...payload];
    },
    clear_topsales(state){
        state.topsales = [];
    },
    clear_category(state){
        state.category = [];
    }
}
export const actions = {
    clear_topsales({commit}){
        commit('clear_topsales');
    },
    clear_category({commit}){
        commit('clear_category');
    },
    async get_topsales({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            commit('topSale');
            try {
                const response = await top_sale_items(payload);
                commit('topSaleDone', response.data);
                resolve(response);
            } catch (error) {
                commit('topSaleFail');
                reject(error);
                throw error
            }
        })
    },
    async get_dashboard({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            commit(types.DARSHBOARD);
            try {
                const response = await get_dashboard(payload);
                commit(types.DARSHBOARD_SUCCESS, response.data);
                resolve(response);
            } catch (error) {
                commit(types.DARSHBOARD_FAIL);
                reject(error);
                throw error
            }
        })
    },
    async summary_sale_report_by_category({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            commit(types.DARSHBOARD_CATEGORY);
            try {
                const response = await summary_sale_report_by_category(payload);
                commit(types.DARSHBOARD_CATEGORY_SUCCESS, response.data);
                resolve(response);
            } catch (error) {
                commit(types.DARSHBOARD_CATEGORY_FAIL);
                reject(error);
                throw error
            }
        })
    },
}
